import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/ui/empty-state';
import { getDashboardUrl } from '@/components/theme-provider';

/**
 * Body of the configuration pages (Settings, Templates, Playground) for an aggregate
 * session. Configuration always belongs to one brand's line, so instead of rendering a
 * page that can only 423 we tell the operator where to go — and the lazy route chunks
 * behind those pages are never fetched.
 */
export function AggregateConfigBanner() {
  const { t } = useTranslation();
  const dashboardUrl = getDashboardUrl();

  return (
    <div className="flex-1 flex items-center justify-center bg-background p-6">
      <EmptyState
        bordered
        className="w-full max-w-md bg-card"
        icon={Lock}
        title={t('aggregate.configLocked.title')}
        description={t('aggregate.configLocked.description')}
        action={
          dashboardUrl && (
            <Button variant="outline" asChild>
              <a href={dashboardUrl}>{t('aggregate.configLocked.action')}</a>
            </Button>
          )
        }
      />
    </div>
  );
}
